module.exports = __webpack_public_path__ + "static/media/iconfont.9a790119.woff";